import React from 'react'
import { BaseFieldProps, WrappedFieldMetaProps } from 'redux-form'
import { HtmlLabelProps, SemanticShorthandItem } from 'semantic-ui-react'
import Label from '../form/Label'

type FilteredFieldProps<P> = Omit<BaseFieldProps<P>, 'component'> // | 'onBlur' | 'onChange' | 'onDragStart' | 'onDrop' | 'onFocus'>

interface ISemanticReduxProps {
  label?: React.ReactNode
}
// eslint-disable-next-line carsys-custom/typescript-prefer-interface-extend-over-intersection
export type SemanticFieldProps<P> = FilteredFieldProps<P> & P & ISemanticReduxProps
// eslint-disable-next-line carsys-custom/typescript-prefer-interface-extend-over-intersection
export type ReduxFieldProps<P> = BaseFieldProps<P> & P & ISemanticReduxProps

export const mapErrorProps = (meta: WrappedFieldMetaProps, label: SemanticShorthandItem<HtmlLabelProps>) => {
  const mappedLabel = typeof label === 'string' ? <Label content={label} {...meta} /> : label
  const error = meta.touched && !!meta.error

  return {
    label: mappedLabel,
    error
  }
}
